import React from 'react';

export default class ContentPage extends React.Component {
  render() {
    return (
      <div>content page</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/content-page/index.js